module.exports = import("/fs3-ui/remoteEntry.js");